import request from "../utils/request.js";
import qs from 'qs';
const encodeBase64 = obj => btoa(unescape(encodeURIComponent(JSON.stringify(obj))));
export function getCTAList(queryParams) {
  return request({
    url: `/cta/list`,
    method: 'GET',
    params: queryParams,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}
export function getCTALog({ pageNum, pageSize, companyId }) {
  return request({
    url: `/cta/log`,
    method: 'GET',
    params: { pageNum, pageSize, companyId }
  });
}

export function getTicketLog(conversationId, companyId) {
  return request({
    url: `/cta/getTicketLog`,
    method: 'GET',
    params: { companyId, conversationId },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}


export function getAllBrands(companyId) {
  return request({
    url: `/cta/brands`,
    method: 'GET',
    params: { companyId },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}

export function updateCTAStatus(data) {
  return request({
    url: `/cta/updateStatusList`,
    method: 'POST',
    data: data,
  });
}

export function getConversationList(id, companyId) {
  return request({
    url: `/cta/listConversation`,
    method: 'GET',
    params: { id, companyId },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' }),
  });
}

export function getCTAImg(id) {
  return request({
    url: `/cta/getCtaImg/` + id,
    method: 'GET',
  });
}

export function exportCTA(data) {
  return request({
    url: `/cta/exportCTA`,
    method: 'POST',
    data: data,
  })
}

export function getExamine(externalRef, conversationId) {
  return request({
    url: `/cta/getCtaListByConversation/${externalRef}/${conversationId}`,
    method: 'GET',
  });
}

export function getExamineLog(externalRef) {
  return request({
    url: `/conversation/examineLogConversation/${externalRef}`,
    method: 'GET',
  });
}

export function ctaCreateTicket(data) {
  return request({
    url: `/cta/ctaCreateTicket`,
    method: 'POST',
    data: data
  });
}

export function createTicket(data) {
  return request({
    url: `/cta/createTicket`,
    method: 'POST',
    data: data
  });
}

export function checkPartnerTicketLimit(data) {
  return request({
    url: `/cta/checkPartnerTicketLimit`,
    method: 'POST',
    data,
  });
}

export function getWorkOrderId(ctaId, companyId,userId) {
  return request({
    url: `/cta/workOrderId`,
    method: 'GET',
    params: {
      ctaId: ctaId,
      companyId: companyId,
      userId: userId
    }
  });
}

export function examineConversation(data) {
  const encoded = encodeBase64(data);
  return request({
    url: `/conversation/examineConversation`,
    method: 'POST',
    data: {
      query: encoded
    },
  });
}